<template>
  <v-flex shrink class="pb-3">
    <v-layout>
      <v-flex shrink>
        <v-card width="250px" class="elevation-5" style="border-radius: 16px">
          <v-list class="py-0" style="background-color: #000">
            <v-list-tile>
              <v-list-tile-title
                style="text-align: center; font-size: 20px; color: white"
                >MESSENGER</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
          <v-list dark class="py-0" style="background-color: #424242">
            <v-list-tile
              v-for="item in filteredSidebar"
              :key="item.title"
              :to="item.link"
            >
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="white--text">{{
                item.title
              }}</v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      menuItems: [
        {
          icon: "queue",
          title: "Add on",
          permission_name: "addon",
          link:
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/messenger/addon",
        },
        {
          icon: "local_shipping",
          title: "Vehicle type",
          permission_name: "vehicle",
          link:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/messenger/vehicletype",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.menuItems.filter((val) => {
        for (let val2 in this.permission.messenger) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
};
</script>
